import { LuCircleX } from 'react-icons/lu';

import { Button } from '~components/ui/button';

type EmptyStateProps = {
  title?: string;
  description?: string;
  className?: string;
  onPrimaryAction?: () => void;
};

const EmptyState = ({ title, description, className, onPrimaryAction }: EmptyStateProps) => {
  return (
    <div className={`flex flex-1 flex-col items-center justify-center p-8 text-center ${className ?? ''}`}>
      <h3 className="mb-4 font-bold text-foreground text-lg">{title}</h3>
      <p className="text-balance text-base text-muted-foreground">{description}</p>
      {onPrimaryAction && (
        <Button className="mt-8" size="sm" onClick={onPrimaryAction}>
          <LuCircleX />
          Clear Filters
        </Button>
      )}
    </div>
  );
};

export { EmptyState };
